import { render, staticRenderFns } from "./DialogDatosHistorico.vue?vue&type=template&id=d85d29a4&scoped=true"
import script from "./DialogDatosHistorico.vue?vue&type=script&lang=js"
export * from "./DialogDatosHistorico.vue?vue&type=script&lang=js"
import style0 from "./DialogDatosHistorico.vue?vue&type=style&index=0&id=d85d29a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d85d29a4",
  null
  
)

export default component.exports